var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-spin',{staticStyle:{"margin-top":"260px"},attrs:{"tip":"登录中，请稍后..."}})
}
var staticRenderFns = []

export { render, staticRenderFns }